export const GET_LEAD_ADS_SUCCESS = 'GET_LEAD_ADS_SUCCESS'
export const DELETE_LEAD_AD_SUCCESS = 'DELETE_LEAD_AD_SUCCESS'
export const SET_FETCHING_LEAD_ADS = 'SET_FETCHING_LEAD_ADS'
